import React from 'react';
const RefundRules = () => {
  return (
    <div>
      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>Train Tickets Cancellation Policy</span>
        </h2>
        <div className={'paddingL40 paddingB10'}>
          <ol type="a">
            <li>
              Customers can logon to MakeMyTrip Website for Cancelling their e-Tickets or Filling TDR. Cancellation can
              be done online and the refund will be credited back to customer’s Card/Bank account used at the time of
              booking.
            </li>
            <li>
              Train Chart is usually prepared 4 hours before departure of train. For train starting morning (up to 12
              noon), the chart preparation is usually done on the previous night.
            </li>
            <li>
              Fully waitlisted tickets will be auto-cancelled by Railways after Chart Preparation and the refund shall
              be automatically credited to customer’s card/back account used at the time of booking.
            </li>
            <li>Agent Service Fee and Payment Gateway Charges charged by MakeMyTrip are non-refundable.</li>
            <li>
              Cancellations and Refund will be based on Indian Rail Refund and TDR filing rules. These rules are
              subjected to change by Indian Railways. MakeMyTrip, though makes an effort to keep latest railways terms
              and conditions and Refund Rules visible on our platform but cannot be held accountable in case of any
              changes.
            </li>
          </ol>
        </div>
      </div>
      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>1) Cancellation Charges for Confirmed Tickets</span>
        </h2>
        <p className={'paddingL20 paddingB5'}>
          The cancellation charges for confirmed ticket are based on the time of cancellation and the status of your
          ticket. Detailed explanations are given below: -
        </p>

        <div className={' paddingL40 '}>
          <ol type="a">
            <li>
              If confirmed e-ticket is cancelled more than 48 hours in advance of the scheduled departure of the train,
              a minimum per passenger cancellation charges shall be deducted at the flat rate:
            </li>
          </ol>
        </div>
        <br />
        <table
          style={{
            textAlign: 'center',
            border: '1px solid lightgrey',
            backgroundColor: '#fafaf8 '
          }}
          className={'pushRight22'}
        >
          <thead>
            <tr>
              <th style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">
                  <span style={{ color: '#006400' }}>
                    <strong>Class of your Ticket</strong>
                  </span>
                </p>
              </th>
              <th style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">
                  <span style={{ color: '#006400' }}>
                    <strong>Cancellation Charges per Passenger</strong>
                  </span>
                </p>
              </th>
            </tr>
          </thead>
          <tbody style={{ width: '100%' }}>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">AC First / Executive Class</p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Rs.240 plus GST</p>
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">First Class / AC 2 Tier</p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Rs.200 plus GST</p>
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">AC Chair Car / AC 3 Tier /AC 3 Economy</p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Rs.180 plus GST</p>
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Sleeper Class</p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Rs.120</p>
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Second Class</p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Rs.60</p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <table
          style={{
            textAlign: 'center',
            border: '1px solid lightgrey',
            backgroundColor: '#fafaf8 '
          }}
          className={'pushRight22'}
        >
          <tbody style={{ width: '100%' }}>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">
                  b) If confirmed e-ticket is cancelled between 48 hours and up to 12 hrs of before scheduled departure
                  of the train.
                </p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">
                  25% of the fare subject to the minimum flat rate mentioned in the above clause 1 (a) plus GST
                  applicable for all AC Classes
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />

        <table
          style={{
            textAlign: 'center',
            border: '1px solid lightgrey',
            backgroundColor: '#fafaf8 '
          }}
          className={'pushRight22'}
        >
          <tbody style={{ width: '100%' }}>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">
                  c) If confirmed e-Ticket is cancelled between 12 hours and up to 4 hours of scheduled departure of the
                  train or up to chart preparation which is earlier.
                </p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">
                  50% of the fare subject to the minimum flat rate mentioned in the above clause.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className={'paddingL20'}>
          <strong>&nbsp;</strong>
        </p>
        <p className={'paddingL20 paddingB5'}>
          <strong>Note</strong>: Chart preparation time is the time for the chart preparation from the Train Originating
          Station or from the Previous Chart Preparation station.
        </p>
        <div className={' paddingL40 '}>
          <ol type="a">
            <li>
              <strong>No refund of fare shall be admissible on the e-tickets having confirmed reservation</strong> in
              case the ticket is not cancelled or TDR not filed online <u>upto 4 hours</u> before the scheduled
              departure of the train.
            </li>
          </ol>
        </div>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              <strong>No refund of fare shall be admissible on RAC</strong> e-tickets in case the ticket is not
              cancelled or TDR not filed online <u>upto 30 minutes</u> before the scheduled departure of the train.
            </li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>2) Cancellation Charges for RAC or Waitlisted Tickets</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              If RAC or Wait-listed e-ticket is cancelled upto 30 mins of scheduled departure of train, the refund shall
              be made after <strong>deducting clerkage charges of Rs.60</strong> (plus GST for AC class).
            </li>
          </ol>
        </div>
        <br />
        <table
          style={{
            textAlign: 'center',
            border: '1px solid lightgrey',
            backgroundColor: '#fafaf8 '
          }}
          className={'pushRight22'}
        >
          <tbody style={{ width: '100%' }}>
            <tr>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">
                  Clerkage Charges on cancellation of RAC and Waitlisted General/Tatkal Tickets
                </p>
              </td>
              <td style={{ border: '1px solid lightgrey', width: '50%' }}>
                <p className="padding10">Rs.60 (plus GST in case of AC Class)</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className={'paddingL20'}>&nbsp;</p>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              No refund shall be granted on RAC ticket or Wait-listed e-ticket after 30 mins before the scheduled
              departure of the train.
            </li>
            <li>
              If Confirmed reservation has been provided to RAC or Wait-listed ticket holder at the time of Chart
              Preparation, such ticket shall be treated as a Reserved Ticket and cancellation charges shall be payable
              in <strong>accordance of Confirmed Tickets (Clause 1)</strong>.
            </li>
          </ol>
        </div>
      </div>
      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>3) Cancellation Charges for Partially Confirmed Tickets</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              In case of e-ticket of more than 1 passenger, if some passengers have Confirmed Reservation and others are
              on RAC or Waiting-list, <u>full refund of fare less clerkage charges of Rs.60 (plus GST)</u> shall be
              admissible for Confirmed passengers also subject to the condition that the e-ticket is cancelled online or
              TDR is filed for all the passengers upto <u>30 mins before</u> the scheduled departure of the train.
            </li>
            <li>
              In case of e-ticket of more than 1 passenger, if some passengers have confirmed reservation and others are
              on RAC or Waiting-list, and RAC or Wait-listed passengers are not travelling, a Certificate is required to
              be obtained from Ticket Checking staff in the train. Passenger is required to file a TDR for those not
              travelled passenger upto 72 hours of actual arrival of train at passenger’s destination.
            </li>
          </ol>
        </div>
        <p style={{ marginLeft: ' 40px' }}>
          Original Certificate is required to be sent through post to “Group General Manager/IT, Indian Railway Catering
          and Tourism Corporation Ltd., Internet Ticketing Centre, IRCA Building, State Entry Road, New Delhi -110055.”
        </p>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>4) Fully Wait-listed Ticket (after chart preparation)</span>
        </h2>
        <p className={'paddingL20'}>
          In case of e-tickets where all passengers are wait-listed even after chart preparation, auto-refund shall be
          processed into customers bank/card account after deducting{' '}
          <strong>Clerkage charges i.e. Rs.60 (plus GST in AC classes).</strong>
        </p>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>5) Refund in case of Train Cancellation</span>
        </h2>
        <p className={'paddingL20'}>
          In case of cancellation of train, full refund of{' '}
          <u>fare shall be directly credited to customer’s card/bank account</u> used at the time of booking on
          MakeMyTrip.
        </p>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>6) Train running more than 3 hours late</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              No Cancellation Charges or Clerkage shall be levied and full fare shall be refunded to all passengers
              holding Confirmed, RAC and Wait-listed tickets, if the journey is not undertaken due to late running of
              the train by more than 3 hours of the scheduled departure of the train from the station commencing journey
              subject to the condition that - TDR is filed online before the actual departure of the train for availing
              full refund.
            </li>
            <li>
              In case the ticket is cancelled or TDR is filed online after the actual departure of train. No refund of
              fare shall be admissible.
            </li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>
            7) Refund if Railway administration is unable to provide accommodation
          </span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Where a railway administration is unable to provide accommodation for any reason whatsoever to passengers
              holding reserved tickets, no cancellation charge shall be levied and full refund of fare shall be granted
              to them if such tickets are surrendered for refund <u>within 3 hours</u> from the actual departure of the
              train.
            </li>
            <li>
              Provided that when the train is cancelled due to unforeseen circumstances such as accident, breach or
              flood, the ticket is surrendered <u>within 3 days </u>excluding the scheduled day of departure of the
              train.
            </li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>8) Refund on Partially Used e-Tickets</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              If passenger terminates the journey en-route, a Certificate shall be issued by Ticket Checking Staff or
              Station Master. The original Certificate has to be sent through post to
            </li>
          </ol>
        </div>
        <p style={{ marginLeft: ' 40px' }}>
          {`"`}Group General Manager/IT, Indian Railway Catering and Tourism Corporation Ltd., Internet Ticketing
          Centre, IRCA Building, State Entry Road, New Delhi - 110055.{`"`}
        </p>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>File TDR online upto 72 hours after the scheduled departure of the train.</li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>9) Refund in case of AC Failure</span>
        </h2>
        <p className={'paddingL20 paddingB5'}>
          For AC Classes, if AC is not provided for part of journey then refund of fare shall be processed for that Part
          of journey basis below conditions:
        </p>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>If Ticket is for AC First Class then fare difference between AC First Class and First Class fare</li>
            <li>If Ticket is for 2AC or 3AC Class then fare difference between 2AC or 3AC and Sleeper Class Fare.</li>
            <li>If Ticket is for AC Chair Car then fare difference between AC Chair Car and Second Class.</li>
            <li>If Ticket is for Executive Class then fare difference between Executive Class and First Class Fare.</li>
          </ol>
        </div>
        <p className={'paddingL20 paddingB5'}>
          In such cases, online TDR should be filed 24 hours of actual arrival of train at passenger’s destination
          station and the original Certificate (GC/EFT) issued by TTE at the time of journey should be send through post
          to Group General Manager/IT, Indian Railway Catering and Tourism Corporation Ltd., Internet Ticketing Centre,
          IRCA Building, State Entry Road, New Delhi - 110055.
        </p>
        <p className={'paddingL20'}>
          Refund will be processed through TDR only after receiving the Original Certificate (GC/EFT). IRCTC will
          forward the claim to Concerned Zonal Railways under whose jurisdiction the train destination falls.&nbsp;
          After&nbsp; receipt&nbsp; of&nbsp; the&nbsp; refund&nbsp; amount&nbsp; from&nbsp; the&nbsp; said&nbsp;
          Railway,&nbsp; refund amount will be credited back to passenger’s account used at the time of booking.
        </p>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>10) Refund if Passenger made to travel in Lower Class</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              If the ticket holder of higher class is made to travel in lower class, refund of fare difference between
              booked class and travelled class will be provided.
            </li>
            <li>Passenger is required to get the Certificate from Ticket Checking Staff (TTE).</li>
            <li>File TDR online within 2 Days of date of issue of certificate.</li>
            <li>
              Send Original Certificate though post to Group General Manager/IT, Indian Railway Catering and Tourism
              Corporation Ltd., Internet Ticketing Centre, IRCA Building, State Entry Road, New Delhi - 110055.
            </li>
            <li>
              Refund will be processed through TDR only after receiving the Original Certificate (GC/EFT). IRCTC will
              forward the claim to Concerned Zonal Railways under whose jurisdiction the train destination falls.
              After&nbsp; receipt&nbsp; of&nbsp; the&nbsp; refund&nbsp; amount&nbsp; from&nbsp; the&nbsp; said&nbsp;
              Railway,&nbsp; refund amount will be credited back to passenger’s account used at the time of booking.
            </li>
          </ol>
        </div>
      </div>
      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>11) Tatkal Tickets</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Tatkal tickets are non-refundable. No refund shall be processed in case of Confirmed Tatkal tickets.
            </li>
            <li>
              Refund in case of RAC and Waitlisted Tatkal Tickets will be as par Clause 2 - Cancellation Charges for RAC
              or Waitlisted Tickets.
            </li>
            <li>
              In case of Tatkal ticket issued for travel for more than one passenger, some passengers have confirmed
              reservation and others are on waiting list, full refund of fare, less clerkage shall be admissible for
              confirmed passengers also subject to the condition that entire Tatkal ticket is cancelled upto 30 mins
              minutes before the scheduled departure of train.
            </li>
            <li>
              If Confirmed Reservation has been provided to RAC or Waitlisted ticket holder at any time upto final&nbsp;
              preparation&nbsp; of&nbsp; charts,&nbsp; such&nbsp; ticket&nbsp; shall&nbsp; be&nbsp; treated&nbsp;
              as&nbsp; confirmed/partially&nbsp; confirmed &nbsp;and Cancellation charges shall be payable as applicable
              to confirmed/partially confirmed tickets.
            </li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>12) Tickets Booked in Premium Special Trains</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Cancellation of both Confirmed and RAC Ticket is not allowed in case the ticket is booked in Premium
              Special Train.
            </li>
            <li>However if the train is cancelled, full refund will be processed into customer’s account.</li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>13) Cancellation of E-Ticket</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              E-Ticket can be cancelled online till preparation of charts and refund will be granted by PRS system as
              per extant Railway Refund Rules.
            </li>
            <li>
              After preparation of charts, the user will have to file online TDR for claiming refund. The refund case
              will be decided by Railways. The TDR can be filed by the same user who books the ticket. After receipt of
              the refund amount from Railway, it shall be credited in customer’s account used at the time of booking.
            </li>
            <li>
              No refund shall be granted on partially Confirmed E-Ticket against which none of the passengers has
              travelled, if TDR is filed after 30 minutes before the scheduled departure of the train.
            </li>
            <li>
              No refund shall be granted on Partial RAC/Waitlisted Ticket against which none of the passengers have
              travelled, if TDR is filed after 30 minutes before the scheduled departure of the train
            </li>
            <li>
              No refund will be granted in case of train running more than 3 hours late and TDR is filled with this
              reason after actual departure of the train.
            </li>
            <li>
              In case of party e-ticket or family e-ticket issued for travel of more than 1 passenger, some passengers
              have confirmed reservation and others are on RAC or waiting list, then in case of passengers on RAC or
              waiting list not travelling, a certificate shall be obtained from the&nbsp;&nbsp; ticket&nbsp; checking
              staff to that effect and refund of fare shall be processed online through TDR, indicating the details of
              the certificate issued by ticket checking staff and the online TDR shall be filed upto 72 hours of actual
              arrival of the train at passengers{"'"} destination and the original certificate issued by ticket&nbsp;
              checking staff shall be sent through post to&nbsp; {`"`}Group General Manager/IT, Indian Railway Catering
              and Tourism Corporation Ltd., Internet Ticketing Centre, IRCA Building, State Entry Road, New Delhi -
              110055.{`"`}
            </li>
            <li>
              The cases in which TDR are filed are decided by the Zonal Railway under whose jurisdiction the train
              destination falls. After receipt of the refund amount from the said Railway, refund amount will be
              credited back to customer’s card/bank account used at the time of booking.
            </li>
            <li>Customer can Cancel their train ticket on MakeMyTrip between 12:20 AM to 11:45 PM only.</li>
            <li>
              If customer is not able to cancel through web interface before Chart Preparation, customers are requested
              to send an email to railservice (at) makemytrip.com.
            </li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>9) Refund in case of AC Failure</span>
        </h2>
        <p className={'paddingL20 paddingB5'}>
          For AC Classes, if AC is not provided for part of journey then refund of fare shall be processed for that Part
          of journey basis below conditions:
        </p>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>If Ticket is for AC First Class then fare difference between AC First Class and First Class fare</li>
            <li>If Ticket is for 2AC or 3AC Class then fare difference between 2AC or 3AC and Sleeper Class Fare.</li>
            <li>If Ticket is for AC Chair Car then fare difference between AC Chair Car and Second Class.</li>
            <li>If Ticket is for Executive Class then fare difference between Executive Class and First Class Fare.</li>
          </ol>
        </div>
        <p className={'paddingL20 paddingB5'}>
          In such cases, online TDR should be filed 24 hours of actual arrival of train at passenger’s destination
          station and the original Certificate (GC/EFT) issued by TTE at the time of journey should be send through post
          to Group General Manager/IT, Indian Railway Catering and Tourism Corporation Ltd., Internet Ticketing Centre,
          IRCA Building, State Entry Road, New Delhi - 110055.
        </p>
        <p className={'paddingL20'}>
          Refund will be processed through TDR only after receiving the Original Certificate (GC/EFT). IRCTC will
          forward the claim to Concerned Zonal Railways under whose jurisdiction the train destination falls.&nbsp;
          After&nbsp; receipt&nbsp; of&nbsp; the&nbsp; refund&nbsp; amount&nbsp; from&nbsp; the&nbsp; said&nbsp;
          Railway,&nbsp; refund amount will be credited back to passenger’s account used at the time of booking.
        </p>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>10) Refund if Passenger made to travel in Lower Class</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              If the ticket holder of higher class is made to travel in lower class, refund of fare difference between
              booked class and travelled class will be provided.
            </li>
            <li>Passenger is required to get the Certificate from Ticket Checking Staff (TTE).</li>
            <li>File TDR online within 2 Days of date of issue of certificate.</li>
            <li>
              Send Original Certificate though post to Group General Manager/IT, Indian Railway Catering and Tourism
              Corporation Ltd., Internet Ticketing Centre, IRCA Building, State Entry Road, New Delhi - 110055.
            </li>
            <li>
              Refund will be processed through TDR only after receiving the Original Certificate (GC/EFT). IRCTC will
              forward the claim to Concerned Zonal Railways under whose jurisdiction the train destination falls.
              After&nbsp; receipt&nbsp; of&nbsp; the&nbsp; refund&nbsp; amount&nbsp; from&nbsp; the&nbsp; said&nbsp;
              Railway,&nbsp; refund amount will be credited back to passenger’s account used at the time of booking.
            </li>
          </ol>
        </div>
      </div>
      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>11) Tatkal Tickets</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Tatkal tickets are non-refundable. No refund shall be processed in case of Confirmed Tatkal tickets.
            </li>
            <li>
              Refund in case of RAC and Waitlisted Tatkal Tickets will be as par Clause 2 - Cancellation Charges for RAC
              or Waitlisted Tickets.
            </li>
            <li>
              In case of Tatkal ticket issued for travel for more than one passenger, some passengers have confirmed
              reservation and others are on waiting list, full refund of fare, less clerkage shall be admissible for
              confirmed passengers also subject to the condition that entire Tatkal ticket is cancelled upto 30 mins
              minutes before the scheduled departure of train.
            </li>
            <li>
              If Confirmed Reservation has been provided to RAC or Waitlisted ticket holder at any time upto final&nbsp;
              preparation&nbsp; of&nbsp; charts,&nbsp; such&nbsp; ticket&nbsp; shall&nbsp; be&nbsp; treated&nbsp;
              as&nbsp; confirmed/partially&nbsp; confirmed &nbsp;and Cancellation charges shall be payable as applicable
              to confirmed/partially confirmed tickets.
            </li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>12) Tickets Booked in Premium Special Trains</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Cancellation of both Confirmed and RAC Ticket is not allowed in case the ticket is booked in Premium
              Special Train.
            </li>
            <li>However if the train is cancelled, full refund will be processed into customer’s account.</li>
          </ol>
        </div>
      </div>

      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>13) Cancellation of E-Ticket</span>
        </h2>
        <div className={' paddingL40 '}>
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              E-Ticket can be cancelled online till preparation of charts and refund will be granted by PRS system as
              per extant Railway Refund Rules.
            </li>
            <li>
              After preparation of charts, the user will have to file online TDR for claiming refund. The refund case
              will be decided by Railways. The TDR can be filed by the same user who books the ticket. After receipt of
              the refund amount from Railway, it shall be credited in customer’s account used at the time of booking.
            </li>
            <li>
              No refund shall be granted on partially Confirmed E-Ticket against which none of the passengers has
              travelled, if TDR is filed after 30 minutes before the scheduled departure of the train.
            </li>
            <li>
              No refund shall be granted on Partial RAC/Waitlisted Ticket against which none of the passengers have
              travelled, if TDR is filed after 30 minutes before the scheduled departure of the train
            </li>
            <li>
              No refund will be granted in case of train running more than 3 hours late and TDR is filled with this
              reason after actual departure of the train.
            </li>
            <li>
              In case of party e-ticket or family e-ticket issued for travel of more than 1 passenger, some passengers
              have confirmed reservation and others are on RAC or waiting list, then in case of passengers on RAC or
              waiting list not travelling, a certificate shall be obtained from the&nbsp;&nbsp; ticket&nbsp; checking
              staff to that effect and refund of fare shall be processed online through TDR, indicating the details of
              the certificate issued by ticket checking staff and the online TDR shall be filed upto 72 hours of actual
              arrival of the train at passengers{"'"} destination and the original certificate issued by ticket&nbsp;
              checking staff shall be sent through post to&nbsp; {'"'}Group General Manager/IT, Indian Railway Catering
              and Tourism Corporation Ltd., Internet Ticketing Centre, IRCA Building, State Entry Road, New Delhi -
              110055.{'"'}
            </li>
            <li>
              The cases in which TDR are filed are decided by the Zonal Railway under whose jurisdiction the train
              destination falls. After receipt of the refund amount from the said Railway, refund amount will be
              credited back to customer’s card/bank account used at the time of booking.
            </li>
            <li>Customer can Cancel their train ticket on MakeMyTrip between 12:20 AM to 11:45 PM only.</li>
            <li>
              If customer is not able to cancel through web interface before Chart Preparation, customers are requested
              to send an email to railservice (at) makemytrip.com.
            </li>
          </ol>
        </div>
      </div>
      <div className="makeFlex column paddingB16">
        <h2 className={'paddingB10'}>
          <span style={{ color: '#000080' }}>14) TDR Refund eligibility as per Railway Refund Rules</span>
        </h2>
        <p className={'paddingL20 paddingB5'}>
          Please note that the decision about the acceptance / rejection or amount of refund will be taken by the
          concerned Zonal Railways as per extant Refund rules of Indian Railways and not by IRCTC or MakeMyTrip.
        </p>
        <br />
        <div className={'scrollBar'}>
          <table
            style={{
              textAlign: 'center',
              border: '1px solid lightgrey',
              backgroundColor: '#fafaf8 ',
              width: '98%'
            }}
            className={'pushRight22'}
          >
            <tbody>
              <tr>
                <th style={{ width: '70px' }} className={'tableHead'}>
                  <p className="padding10">
                    <span style={{ color: '#006400' }}>
                      <strong>Sr. No.</strong>
                    </span>
                  </p>
                </th>
                <th className={'tableHead'}>
                  <p className="padding10">
                    <span style={{ color: '#006400' }}>
                      <strong>TDR Filing Reason</strong>
                    </span>
                  </p>
                </th>
                <th className={'tableHead'}>
                  <p className="padding10">
                    <span style={{ color: '#006400' }}>
                      <strong>Refund Eligibility&nbsp; as per&nbsp; Railway&nbsp; Refund Rules</strong>
                    </span>
                  </p>
                </th>
              </tr>

              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">1</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Train Cancelled</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    No Need to File TDR. Refund will be processed automatically in customer{"'"}s account.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">2</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Train Late more than 3 Hours and Passenger not travelled.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed before the actual departure of the train for availing full refund.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">3</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    Difference of fare in case proper coach not attached and passenger has to travel in Lower Class
                  </p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed within two days of the date of issue of the certificate(excluding the day of
                    issue of he certificate) and the original certificate (GC/EFT) issued by the ticket checking staff
                    is to be sent through post to IRCTC.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">4</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">AC Failure</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed within 24 hrs of actual arrival of the train at passenger’s destination and the
                    Original Certificate (GC/EFT) issued by the ticket checking staff is to be sent through post to
                    IRCTC.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">5</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Excess fare Charged BY TTE</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed upto 72 hrs of actual arrival of the train at passenger’s destination and the
                    Original Certificate (GC/EFT) issued by the ticket checking staff is to be sent through post to
                    IRCTC.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">6</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Party Partially Travelled.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed upto 72 hrs of actual arrival of the train at passenger’s destination and the
                    Original Certificate (GC/EFT) issued by the ticket checking staff is to be sent through post to
                    IRCTC.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">7</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Passenger Not Travelled.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    No refund of fare shall be admissible on the ticket having confirmed reservation&nbsp;&nbsp; in case
                    ticket is not cancelled or TDR not filed online upto 4 hours before the scheduled departure of the
                    train.
                    <br /> No refund of fare shall be admissible on RAC e-tickets in case the ticket is not cancelled or
                    TDR not filed online upto 30 minutes before the scheduled departure of the train.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">8</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Train&nbsp; Diverted And Passenger Not Travelled</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed upto 72 hrs of schedule departure of the train at passenger’s Boarding station.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">9</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Train Diverted And Train Not Touching Boarding Station.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed upto 72 hrs of schedule departure of the train at passenger’s Boarding station.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">10</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Train Diverted And Train Not Touching Destination Station.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed upto 72 hrs of schedule departure of the train at passenger’s Boarding station.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">11</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Passenger Not Travelled Due To Ticket In RAC After Chart Preparation.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    No refund of fare shall be admissible on RAC e-tickets in case the ticket is not cancelled or TDR is
                    not filed online upto 30 mins before the scheduled departure of the train.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">12</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Train Terminated Short Of Destination.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR&nbsp; shall&nbsp; be&nbsp; filed&nbsp; upto&nbsp; 72 hrs of schedule&nbsp;&nbsp;
                    arrival&nbsp;&nbsp; of&nbsp;&nbsp; the&nbsp;&nbsp; train&nbsp;&nbsp; at&nbsp;&nbsp; passenger’s
                    destination&nbsp; and&nbsp; the&nbsp; original&nbsp; certificate&nbsp; (GC/EFT)&nbsp; issued&nbsp;
                    by&nbsp; the&nbsp; ticket&nbsp; checking&nbsp; staff&nbsp; is&nbsp; to&nbsp; be&nbsp; sent&nbsp;
                    through post to IRCTC.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">13</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    Party Partially Confirmed/Waitlisted And Waitlisted Passengers Did Not Travel.
                  </p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    TDR shall be filed upto 72 hrs hours of actual arrival of the train at passenger’s destination and
                    the original certificate (GC/EFT) issued by the ticket
                    <br /> Travel checking staff is to be sent through post to IRCTC.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">14</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">Party Partially Confirmed/Waitlisted And All Passengers Did Not Travel.</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    No refund shall be granted on Reserved/RAC/waitlisted ticket if TDR filed and all Passengers did not
                    travel after 30 mins before scheduled departure of the train.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">15</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    Party Could Not Cancel Because Chart Prepared At Originating Or Previous Remote Location.
                  </p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    No refund of fare shall be admissible on the ticket having confirmed reservation in case ticket is
                    not cancelled or TDR not filed online upto 4 hours before the scheduled departure of the train.
                    <br /> No refund of fare shall be admissible on RAC e-tickets in case the ticket is not cancelled or
                    TDR not filed online upto thirty minutes before the scheduled departure of the train.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">16</p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    Change In Reservation Status from Confirmed To Waitlisted/Part Waitlisted/RAC After Chart
                    Preparation.
                  </p>
                </td>
                <td style={{ border: '1px solid lightgrey' }}>
                  <p className="padding10">
                    No refund shall be granted on RAC ticket or waitlisted ticket after 30 mins before the scheduled
                    departure of the train.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p className={'paddingL20'}>&nbsp;</p>
    </div>
  );
};
export default RefundRules;
